import React from 'react';
import isEqual from 'lodash/isEqual';
import GenericLink from 'components/GenericLink';
import './WebDataDoesNotRock.styl';
import {Moment} from 'moment';
import moment from 'moment/moment';
import WebDataRocksActions from '@store/web-data-rocks/WebDataRocksActions';
import DashboardDateRangeActions from 'actions/dashboard/DasbhoardDateRangeActions';
import {DateFormat} from 'utils/datetime/DateFormat';

interface WebDataDoesNotRockProps {
  readonly suggestedRanges: [string, string] | null;
  readonly startDate: Moment;
  readonly endDate: Moment;
}

function fmtRange([start, end]) {
  return (
    <span>
      <strong>{start}</strong> to <strong>{end}</strong>
    </span>
  );
}

function setAndHide([start, end]: [string, string]) {
  DashboardDateRangeActions.setDateRange({
    startDate: moment(start, DateFormat.MM_DD_YYYY),
    endDate: moment(end, DateFormat.MM_DD_YYYY),
  });
  WebDataRocksActions.hideDialog();
}

export default class WebDataDoesNotRock extends React.PureComponent<WebDataDoesNotRockProps> {
  render() {
    const {suggestedRanges, startDate, endDate} = this.props;
    if (!suggestedRanges) return null;

    return (
      <div className="web-data-does-not-rock">
        <div>
          <h3>Please restrict data range</h3>
          <p>
            Your query range{' '}
            {fmtRange([
              startDate.format(DateFormat.MM_DD_YYYY),
              endDate.clone().subtract(1, 'days').format(DateFormat.MM_DD_YYYY),
            ])}{' '}
            returned too many results to display.
          </p>
          <p>
            You can try restricting the date range to a shorter period - we suggest{' '}
            <Ranges
              fromStart={[startDate.format(DateFormat.MM_DD_YYYY), suggestedRanges[0]]}
              fromEnd={[
                suggestedRanges[1],
                endDate.clone().subtract(1, 'days').format(DateFormat.MM_DD_YYYY),
              ]}
            />
            .
          </p>
        </div>
      </div>
    );
  }
}

function Ranges({fromStart, fromEnd}) {
  if (isEqual(fromStart, fromEnd)) {
    // If the ranges are equal, don't show both
    return <GenericLink onClick={() => setAndHide(fromStart)}>{fmtRange(fromStart)}</GenericLink>;
  }

  return (
    <span>
      <GenericLink onClick={() => setAndHide(fromStart)}>{fmtRange(fromStart)}</GenericLink>
      {' or '}
      <GenericLink onClick={() => setAndHide(fromEnd)}>{fmtRange(fromEnd)}</GenericLink>
    </span>
  );
}
